import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";

export class SoftwareName {
    swType: UpdateTypeEnum;
    name: string;

    constructor(swType: UpdateTypeEnum, name: string) {
        this.swType = swType;
        this.name = name;
    }
}
